import { render, staticRenderFns } from "./tzddtgz.vue?vue&type=template&id=01d398f4&scoped=true&"
import script from "./tzddtgz.vue?vue&type=script&lang=js&"
export * from "./tzddtgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d398f4",
  null
  
)

export default component.exports